import React, { Component } from "react";
import PropTypes from "prop-types";
import { Img } from "glamorous";
import icons from "../../../imgs/icons";
import styles from "../../../styles";
import TextSpan from "./TextSpan";

class PreviewRead extends Component {
  state = {
    ratio: 1
  };

  componentDidMount() {
    this.ratioUpdate();
    window.addEventListener("resize", this.ratioUpdate.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.ratioUpdate.bind(this));
  }

  ratioUpdate() {
    if (!this.previewImageEl) {
      // until render
      return;
    }

    this.setState({
      ratio: this.previewImageEl.clientWidth / 563
    });
  }

  render() {
    return (
      <div style={styles.editor.preview}>
        <Img css={styles.editor.previewImage} innerRef={el => this.previewImageEl = el} src={this.props.label.background} />
        <Img css={styles.editor.cutLineLeft} src={icons.cutLine} />
        <Img css={styles.editor.cutLineRight} src={icons.cutLine} />
        {this.renderText()}
      </div>
    );
  }

  renderText() {
    const { text } = this.props.label;
    const { ratio } = this.state;
    return text.map((text, index) => {
      if (text.skip) {
        return null;
      }

      return <TextSpan
          text={text}
          handleTextClick={this.props.handleTextClick}
          index={index}
          key={index}
          ratio={ratio}
        />
    });
  }
}

PreviewRead.propTypes = {
  label: PropTypes.object.isRequired,
  handleTextClick: PropTypes.func,
  outline: PropTypes.bool
};

export default PreviewRead;



// WEBPACK FOOTER //
// ./src/components/areas/Preview/Read.js